import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}fechaDesde=${params.FechaDesde}`);
  params.FechaHasta &&
    (path = `${path !== '' ? `${path}&` : ''}fechaHasta=${setHoursEndOfDate(params.FechaHasta)}`);
  params.Estado &&
    params.Estado.Codigo > 0 &&
    (path = `${path !== '' ? `${path}&` : ''}estado=${params.Estado.Codigo}`);
  params.Cliente && (path = `${path !== '' ? `${path}&` : ''}cliente=${params.Cliente}`);
  params.CodigoCliente &&
    (path = `${path !== '' ? `${path}&` : ''}codigoCliente=${params.CodigoCliente}`);
  params.Vendedor && (path = `${path !== '' ? `${path}&` : ''}vendedor=${params.Vendedor}`);
  params.OrdenCompra &&
    (path = `${path !== '' ? `${path}&` : ''}ordenCompra=${params.OrdenCompra}`);
  params.CodigoPedido &&
    (path = `${path !== '' ? `${path}&` : ''}codigoPedido=${params.CodigoPedido}`);
  params.CodigoProductoPedido &&
    (path = `${path !== '' ? `${path}&` : ''}codigoProductoPedido=${params.CodigoProductoPedido}`);
  params.DescripcionProducto &&
    (path = `${path !== '' ? `${path}&` : ''}producto=${params.DescripcionProducto}`);
  params.TipoProducto &&
    (path = `${path !== '' ? `${path}&` : ''}tipoProducto=${params.TipoProducto}`);
  params.CodigoElementoGrupo &&
    (path = `${path !== '' ? `${path}&` : ''}codigoElementoGrupo=${params.CodigoElementoGrupo}`);

  return path;
};

const setHoursEndOfDate = (fecha) => {
  if (fecha) {
    const fechaSeleccionada = new Date(fecha);
    fechaSeleccionada.setHours(23, 59, 59, 999);
    return fechaSeleccionada;
  }
  return fecha;
};
